import { render, staticRenderFns } from "./ModalUsePoints.vue?vue&type=template&id=09d7e1c3&scoped=true"
import script from "./ModalUsePoints.vue?vue&type=script&lang=js"
export * from "./ModalUsePoints.vue?vue&type=script&lang=js"
import style0 from "./ModalUsePoints.vue?vue&type=style&index=0&id=09d7e1c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7e1c3",
  null
  
)

export default component.exports